<template>
  <div class="menu-wrapper" v-if="user">
    <template v-for="item in routes">
      <router-link v-if="item.path" :to="item.path" :key="item.name">
        <el-menu-item :index="item.name" :class="{'submenu-title-noDropdown':!isNest}">
          <i v-if="item.icon" :class="item.icon"></i>
          <span v-if="item.name" slot="title">{{item.name}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-if="item.items && item.items.length>0" :index="item.name" :key="item.name">
        <template slot="title">
          <i v-if="item.icon" :class="item.icon"></i>
          <span v-if="item.name" slot="title">{{item.name}}</span>
        </template>

        <template v-for="child in item.items">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.items&&child.items.length>0" :routes="[child]" :user="user" :key="child.path"></sidebar-item>

          <router-link v-else :to="child.path" :key="child.name">
            <el-menu-item :index="child.path">
              <i v-if="child.icon" :class="child.icon"></i>
              <span v-if="child.name" slot="title">{{child.name}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    user:null,
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue